import { isObject } from '@/helpers/isObject';
import { windowIsReady } from '@/helpers/windowIsReady';

export const LocalStorageService = {
	get<T>(key: string, defaultValue: T): T {
		if (windowIsReady) {
			const saved = localStorage.getItem(key);

			try {
				const initial = saved ? JSON.parse(saved) : null;
				return initial ?? defaultValue;
			} catch (error) {
				return saved ? (saved as T) : defaultValue;
			}
		}

		return defaultValue;
	},
	set(key: string, value: any) {
		if (windowIsReady) {
			localStorage.setItem(
				key,
				isObject(value) ? JSON.stringify(value) : value,
			);
		}
	},
	remove(key: string) {
		if (windowIsReady) {
			localStorage.removeItem(key);
		}
	},
	clear() {
		if (windowIsReady) {
			localStorage.clear();
		}
	},
};
